<template>
  <div class="box">
    <div class="box-title" v-if="pkData.isNow">{{ pkData.battleName }}</div>
    <div class="box-title-history" v-else></div>
    <div class="box-type">{{ pkData.battleType === 1 ? '激活率PK' : '扫码率PK' }}</div>
    <div class="box-time" v-show="!pkData.isNow">PK时间：{{ this.pkData.battleStartTime }} - {{ this.pkData.battleEndTime }}</div>
    <div class="box-content">
      <div class="box-data" v-for="(item, index) in pkList" :key="index">
        <div class="city-name">{{ item.participantName }}</div>
        <div class="box-city-data">
          <data-progress :progress="item.ratio"></data-progress>
        </div>
        <div class="city-ratio">{{ item.ratio }}%</div>
      </div>
    </div>
    <div class="show-more" @click="handleView" v-if="pkData.battleParticipantList.length > 5">
      {{ viewMore ? '收起' : '点击查看更多' }}
    </div>
    <div class="box-result" v-show="!pkData.isNow">
      <div>
        <img v-for="(item, index) in winCity" :key="index" :src="item">
      </div>
    </div>
  </div>
</template>

<script>
import dataProgress from './data-progress'
import { commonUtils } from '@/utils/common'
export default {
  props: {
    pkData: Object
  },
  data () {
    return {
      winCity: [],
      pkList: [],
      viewMore: false
    }
  },
  components: {
    'data-progress': dataProgress
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.pkData.battleParticipantList.forEach(item => {
        if (item.ratio > 100) {
          item.ratio = 100
        }
      })
      this.pkData.battleStartTime = commonUtils.parseTime(this.pkData.battleStartTime, '{y}/{m}/{d}')
      this.pkData.battleEndTime = commonUtils.parseTime(this.pkData.battleEndTime, '{y}/{m}/{d}')
      if (!this.pkData.isNow) {
        if (this.pkData.battleParticipantList.length) {
          for (let i = 0; i < this.pkData.battleParticipantList.length; i++) {
            if (this.pkData.battleParticipantList[i].ratio === this.pkData.battleParticipantList[0].ratio) {
              this.winCity.push(this.checkCity(this.pkData.battleParticipantList[i].cityName, this.pkData.battleType))
            } else {
              break
            }
          }
        }
      }
      this.pkList = this.pkData.battleParticipantList.slice(0, 5)
    },
    handleView () {
      this.viewMore = !this.viewMore
      if (!this.viewMore) {
        this.pkList = this.pkData.battleParticipantList.slice(0, 5)
      } else {
        this.pkList = this.pkData.battleParticipantList
      }
    },
    checkCity (name, type) {
      let city = ''
      switch (name) {
        case '上海市':
          city = require('../../../assets/images/activity/shanghai.png')
          break
        case '广州市':
          if (type === 2) {
            city = require('../../../assets/images/activity/guangzhou.png')
          } else if (type === 1) {
            city = require('../../../assets/images/activity/guangzhoufoshan.png')
          }
          break
        case '深圳市':
          city = require('../../../assets/images/activity/shenzhen.png')
          break
        case '宁波市':
          city = require('../../../assets/images/activity/ningbo.png')
          break
        case '苏州市':
          city = require('../../../assets/images/activity/suzhou.png')
          break
        case '成都市':
          city = require('../../../assets/images/activity/chengdu.png')
          break
        case '石家庄市':
          city = require('../../../assets/images/activity/shijiazhuang.png')
          break
        case '杭州市':
          city = require('../../../assets/images/activity/hangzhou.png')
          break
        case '西安市':
          city = require('../../../assets/images/activity/xian.png')
          break
        case '北京市':
          city = require('../../../assets/images/activity/beijing.png')
          break
        case '常州市':
          city = require('../../../assets/images/activity/changzhou.png')
          break
        case '重庆市':
          city = require('../../../assets/images/activity/chongqing.png')
          break
        case '合肥市':
          city = require('../../../assets/images/activity/hefei.png')
          break
        case '呼和浩特市':
          city = require('../../../assets/images/activity/huhehaote.png')
          break
        case '济南市':
          city = require('../../../assets/images/activity/jinan.png')
          break
        case '济宁市':
          city = require('../../../assets/images/activity/jining.png')
          break
        case '昆明市':
          city = require('../../../assets/images/activity/kunming.png')
          break
        case '南京市':
          city = require('../../../assets/images/activity/nanjing.png')
          break
        case '南宁市':
          city = require('../../../assets/images/activity/nanning.png')
          break
        case '沈阳市':
          city = require('../../../assets/images/activity/shenyang.png')
          break
        case '太原市':
          city = require('../../../assets/images/activity/taiyuan.png')
          break
        case '天津市':
          city = require('../../../assets/images/activity/tianjin.png')
          break
        case '武汉市':
          city = require('../../../assets/images/activity/wuhan.png')
          break
        case '厦门市':
          city = require('../../../assets/images/activity/xiamen.png')
          break
        case '徐州市':
          city = require('../../../assets/images/activity/xuzhou.png')
          break
        case '郑州市':
          city = require('../../../assets/images/activity/zhengzhou.png')
          break
        case '佛山市':
          city = require('../../../assets/images/activity/foshan.png')
          break
        default:
          break
      }
      return city
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  border-radius: 5px;
  position: relative;
  border: 1px solid #fff;
}
.box-title {
  width: 154px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  text-align: center;
  font-weight: bold;
  color: #fff;
  position: absolute;
  left: 50%;
  margin-left: -77px;
  top: -20px;
  border-radius: 5px;
  overflow: hidden;
  background: url("../../../assets/images/title.png") no-repeat;
  background-size: 100% 100%;
}
.box-title-history {
  width: 150px;
  height: 40px;
  position: absolute;
  left: 50%;
  margin-left: -75px;
  top: -20px;
  border-radius: 5px;
  overflow: hidden;
  background: url("../../../assets/images/title-history.png") no-repeat;
  background-size: 100% 100%;
}
.box-type {
  width: 70px;
  height: 25px;
  font-size: 12px;
  font-weight: bold;
  color: #4b77ba;
  line-height: 25px;
  text-align: center;
  background-color: #c3cfe6;
  border-radius: 4px 0px 10px 0px;
}
.box-content {
  padding: 0 0 17px 5px;
}
.box-data {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.city-name {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  width: 105px;
  text-align: center;
}
.city-ratio {
  color: #fff;
  font-size: 16px;
  margin-left: 10px;
}
.box-city-data {
  width: 180px;
}
.box-time {
  color: #a0b5d9;
  font-size: 12px;
  text-align: center;
}
.box-result {
  width: 336px;
  height: 100px;
  position: relative;
  margin: -10px auto 8px auto;
  background: url("../../../assets/images/activity/bg.png") no-repeat;
  background-size: 100% 100%;
  div {
    height: 26px;
    width: 100%;
    position: absolute;
    bottom: 2px;
    text-align: center;
    margin-left: -6px;
    img {
      height: 100%;
      margin: 0 8px;
    }
  }
}
.show-more {
  color: #fff;
  text-align: center;
  margin-bottom: 10px;
}
</style>
